import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Delete,
  GetAll,
} from "../../../../features/admin/customer-management/driver/Slice";
import { Status } from "../../../../features/admin/customer-management/customer/Slice";

export const IndexUse = () => {
  const dispatch = useDispatch();
  const country = useSelector((state) => state.customermanagement.drivers);

  const [first_name, setName] = useState("");
  const [email, setemail] = useState("");
  const [contact_no, setcontact_no] = useState("");
  const [vehicleType, setVehicleType] = useState("");
  const [driverStatus, setDriverStatus] = useState("");

  useEffect(() => {
    fetch();
  }, [first_name, email, contact_no, vehicleType, driverStatus]);

  const fetch = async (page = country?.current_page) => {
    await dispatch(
      GetAll({
        first_name,
        email,
        contact_no,
        vehicleType,
        driverStatus,
        page,
        per_page: country?.per_page,
      }),
    );
  };

  // const deleteData = async (id) => {
  //   try {
  //     await dispatch(Delete(id));
  //     await fetch();
  //     return true;
  //   } catch (error) {
  //     console.error(error);
  //     return false;
  //   }
  // };

  const toggleStatus = async (id) => {
    try {
      await dispatch(Status(id));
      await fetch();
      return true;
    } catch (error) {
      console.error(error);
      return false;
    }
  };

  return {
    country,
    first_name,
    setName,
    email,
    setemail,
    contact_no,
    setcontact_no,
    vehicleType,
    setVehicleType,
    fetch,
    // deleteData,
    toggleStatus,
    driverStatus,
    setDriverStatus,
  };
};
